import { useMemo } from 'react'

type UsePdpProductUrlParams = {
    urlKey?: string
    asPath?: string
}

export function usePdpProductUrl({
    urlKey,
    asPath
}: UsePdpProductUrlParams): string {
    return useMemo(() => {
        if (urlKey) return urlKey
        const afterPrefix = (asPath || '').split('/producto/')[1]
        if (!afterPrefix) return ''
        return afterPrefix
            .split(/[?#]/)[0]
            .replace('.html', '')
            .replace(/\/$/, '')
    }, [urlKey, asPath])
}
